import React from 'react';
import { View } from 'react-native';
import { GridLayoutWithRightContent } from './Layouts/GridLayoutWithRightContent';
import { createAppContainer } from 'react-navigation';
import { TrackingTabNavigation } from 'fitbeat.react-native-components';

const TrackingTabNav = createAppContainer(TrackingTabNavigation);
export const StatsScreenContainer = (props) => (
    <GridLayoutWithRightContent {...props}>
        <View className='full-height' style={{ flex: 1, zIndex: 1 }}>
            <TrackingTabNav screenProps={props}  />
        </View>
    </GridLayoutWithRightContent>
);
